<template>
  <div class="container">
    <app-header title="成为VIP创客"/>
    <div class="top">
      <div class="top-main">
        <div class="top-title">超值大礼包</div>
        <div class="top-money">￥{{giftInfo.total}}</div>
        <div class="top-btn" @click="show = !show">查看详情</div>
      </div>
    </div>
    <div class="top-content" v-show="show">
      <div class="top-item" v-for="(item,index) in giftInfo.couponList" :key="index">
        <div class="top-item-money">￥{{item.money}}</div>
        <div class="top-item-text">{{$enums.ProductType[item.type]}}</div>
      </div>
    </div>

    <div class="app-main">
      <div class="flex-between" style="align-items: center">
        <div class="feiyong">大礼包金额: ￥{{giftInfo.fee}}</div>
        <div class="tip">赠送高级VIP创客会员一年</div>
      </div>

      <div class="fangshi">支付方式</div>
      <div class="choose">
        <van-radio-group v-model="radio">
          <!--<div class="item"  v-if="userInfo.income >= giftInfo.fee">-->
            <!--<div class="name">-->
              <!--<img src="@/assets/pay03.png" alt="" width="20" height="20">-->
              <!--<span class="text">返利金额抵扣</span>-->
            <!--</div>-->
            <!--<van-radio :name="0" class="radio" checked-color="#FE003B"></van-radio>-->
          <!--</div>-->
          <div class="item">
            <div class="name">
              <img src="@/assets/pay04.png" alt="" width="20" height="20">
              <span class="text">余额支付</span>
            </div>
            <van-radio :name="1" class="radio" checked-color="#FE003B"></van-radio>
          </div>
          <div class="item">
            <div class="name">
              <img src="@/assets/pay05.png" alt="" width="20" height="20">
              <span class="text">微信支付</span>
            </div>
            <van-radio :name="2" class="radio" checked-color="#FE003B"></van-radio>
          </div>
        </van-radio-group>
      </div>

      <div class="promptly" @click="submit" style="margin-top: 25px">立即支付</div>
    </div>

  </div>
</template>

<script>
  import {vipPayBalance, vipBuyBalance, queryVipPayBalance} from '@/api/vip/index.js'
  import {getGiftInfo} from '@/api/coupon/index.js'
  import {getCurtUser} from '@/api/login/index.js'
  export default {
    name: 'Attestation',
    data() {
      return {
        show: false,
        radio: 1,
        form: {},
        userInfo: {},
        giftInfo: {
          fee: 0,
          total: 0,
          couponList: []
        }
      }
    },
    created() {
      //用户信息
      var user = localStorage.getItem("userInfo")
      if (!user){
        this.$router.push({path: '/login'})
        return;
      }
      user = JSON.parse(user)
      this.form.uid = user.id
      this.getGiftInfo();
    },
    methods: {
      getGiftInfo(){
        getGiftInfo({}).then((res) => {
          if (res.success) {
            this.giftInfo = res.data
          }
        })
      },
      getUser(){
        getCurtUser({id: this.form.uid}).then(res => {
          if (res.success) {
            this.userInfo = res.data
            if (this.userInfo.income < this.giftInfo.fee) {
              this.radio = 1;
            }
          }
        })
      },
      submit() {
        if (this.radio == 1) {
          this._vipBuyBalance();
        }
        if (this.radio == 2) {
          this._vipPayBalance();
        }
      },
      _vipBuyBalance() {
        let params = {
          type: 1,
          payType: this.radio,
          uid: this.form.uid,
          money: this.giftInfo.fee
        }
        vipBuyBalance(params).then((res) => {
          if (res.success) {
            this.$router.back();
            // this.$router.push({
            //   path: '/mine/vip/interests'
            // })
          } else {
            this.$toast.fail(res.msg);
          }
        })
      },
      _vipPayBalance() {
        var user = JSON.parse(localStorage.getItem('userInfo'))
        if (!user) {
          this.$router.push({path: '/login'})
          return;
        }
        let params = {
          type: 1,
          payType: this.radio,
          uid: this.form.uid,
          openid: localStorage.getItem('openid'),
          money: this.giftInfo.fee
        }
        vipPayBalance(params).then((res) => {
          if (res.success) {
            const data = res.payMap
            WeixinJSBridge.invoke(
              'getBrandWCPayRequest', {
                appId: data.appId, // 公众号名称(商户appid)
                timeStamp: data.timeStamp, // 时间戳，自1970年以来的秒数
                nonceStr: data.nonceStr, // 随机串
                package: data.package,
                signType: data.signType, // 微信签名方式：
                paySign: data.paySign // 微信签名
              }, (r) => {
                if (r.err_msg == 'get_brand_wcpay_request:ok') {
                  this.$router.back();
                  // this.$router.push({
                  //   path: '/mine/vip/interests'
                  // })
                  return;

                }
              })
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .container {
    padding-top: 50px;
    background: #EDEDED;
    .top {
      display: flex;
      flex-direction: row-reverse;
      width: 100%;
      height: 132px;
      background-image: url(../../../assets/vip-bg.png);
      background-size: cover;
      background-position: 50%;
      padding: 12px;
      box-sizing: border-box;
      .top-main {
        width: 223px;
        background: #FFFFFF;
        .top-title {
          height: 20px;
          font-size: 14px;
          font-weight: 800;
          line-height: 20px;
          color: #333333;
          margin-left: 8px;
        }
        .top-money {
          height: 40px;
          font-size: 28px;
          font-weight: 800;
          line-height: 40px;
          color: #FE003B;
          text-align: center;
        }
        .top-btn {
          width: 90px;
          height: 29px;
          background: linear-gradient(180deg, #F8D8B1 0%, #FFB760 100%);
          box-shadow: 0px 2px 4px rgba(236, 129, 0, 0.4);
          border-radius: 15px;
          font-size: 14px;
          font-weight: bold;
          line-height: 29px;
          color: #9F0103;
          margin: auto;
          text-align: center;
          margin-top: 6px;
        }
      }
    }
    .top-content {
      height: auto;
      padding: 11px 25px;
      background: #FFFFFF;
      margin: -12px 12px 12px 12px;
      box-sizing: border-box;

      .top-item {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        height: 82px;
        background-image: url(../../../assets/coupon.png);
        background-size: cover;
        background-position: center;
        margin-bottom: 4px;
        .top-item-money {
          height: 33px;
          font-size: 24px;
          font-weight: 800;
          line-height: 33px;
          color: #FFFFFF;
        }
        .top-item-text {
          height: 25px;
          font-size: 18px;
          font-weight: bold;
          line-height: 25px;
          color: #333333;
        }
      }
    }
    .app-main {
      background: #FFFFFF;
      border-radius: 20px 20px 0px 0px;
    }
    .feiyong {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 28px;
      color: rgba(51, 51, 51, 1);
      padding: 22px 22px 22px 12px;
      opacity: 1;
    }
    .tip{
      color: red;
      padding-right: 22px;
    }
    .choose {
      padding: 0 15px;
      .item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 10px 0;
        .name {
          display: flex;
          flex-direction: row;
          align-items: center;
          .text {
            display: inline-block;
            margin-left: 10px;
          }
        }
      }
    }
    .fangshi {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 20px;
      color: rgba(102, 102, 102, 1);
      margin-left: 12px;
      opacity: 1;
    }
    .promptly {
      width: 95%;
      margin-left: 2%;
      height: 46px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(226, 226, 226, 1);
      opacity: 1;
      border-radius: 4px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 46px;
      color: rgba(102, 102, 102, 1);
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/vip/attestation.vue